import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import { registerInstance } from '../mutators/taskModuleInstancesMutators';
import {
    registerCloseDialog,
    registerOpenDialog,
    registerUpdateDialog,
} from '../mutators/taskModuleMutators';
import getInstance from '../selectors/getTaskModuleInstance';
import { InstanceStore } from '../store/schema/TaskModuleInstances';

import type { PromiseHandlers, DialogActions } from 'owa-app-host-services';

export interface TaskModuleState extends TaskModuleSatchelState {
    usePromiseState: () => PromiseHandlers;
}

export interface TaskModuleSatchelState {
    store: InstanceStore;
    actions: DialogActions;
}

function registerTaskModule(): TaskModuleSatchelState {
    const instanceId = uuidv4();
    registerInstance(instanceId);
    const actions = {
        open: registerOpenDialog(instanceId),
        close: registerCloseDialog(instanceId),
        update: registerUpdateDialog(instanceId),
    };
    const store = getInstance(instanceId);
    return {
        store: store as InstanceStore,
        actions,
    };
}

export default function newTaskModule(): TaskModuleState {
    const { store, actions } = registerTaskModule();

    // DialogService's promise handlers
    const usePromiseState = () => {
        const [onDismissPromise, setOnDismissPromise] = React.useState({
            handle: () => actions.close(),
        });
        const [onSubmitPromise, setOnSubmitPromise] = React.useState({ handle: () => undefined });

        return {
            get onSubmit() {
                return onSubmitPromise.handle;
            },
            set onSubmit(callback) {
                setOnSubmitPromise({ handle: callback });
            },
            get onDismiss() {
                return onDismissPromise.handle;
            },
            set onDismiss(callback) {
                setOnDismissPromise({ handle: callback });
            },
        };
    };

    return {
        store,
        actions,
        usePromiseState,
    };
}
